import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditOutgoingServer = mutatorAction('updateEditOutgoingServer', function (server) {
    var store = connectedAccountsStore();
    store.editAccountState.outgoingServer = server;
});
//# sourceMappingURL=updateEditOutgoingServer.js.map